import { PortalType } from "@studyportals/domain-client";

export const useEventSender = (): { sendChangeCurrencyEvent: () => void, sendInitialEvents: (portalType: PortalType) => void } => {
	const eligibleTypes = [PortalType.MASTER, PortalType.BACHELOR, PortalType.DISTANCE_LEARNING];

	const sendInitialEvents = (portalType: PortalType): void => {
		sendGlobalAccessInitiativeEvent(portalType);
		sendBestFitEvents(portalType);
		sendWishlistEvents();
	}

	const sendChangeCurrencyEvent = (): void => {
		const event = new CustomEvent('open_localization_settings');
		document.dispatchEvent(event);
	}

	const sendGlobalAccessInitiativeEvent = (portalType: PortalType): void => {
		if (eligibleTypes.includes(portalType)) {
			sendCustomEvent('profile_questionnaires_initialize', {
				identifier: 'search_global_access_initiative_label',
			});

			sendCustomEvent('profile_questionnaires_initialize', {
				identifier: 'search_scholarship_incentive_label',
			});
		}
	}

	const sendBestFitEvents = (portalType: PortalType): void => {
		if (portalType === PortalType.MASTER) {
			sendCustomEvent('profile_questionnaires_initialize', {
				identifier: 'bestfit_search',
			});
			sendCustomEvent('render_best_fit_templates');
		}
	}

	const sendWishlistEvents = (): void => {
		sendCustomEvent('wishlist_button_initialize');
	}

	const sendCustomEvent = (eventName: string, detail: Record<string, unknown> = {}): void => {
		document.dispatchEvent(new CustomEvent(eventName, { detail }));
	}

	return { sendChangeCurrencyEvent, sendInitialEvents };
}